import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  CreateCurrencyAccount,
  CreateCurrencyAccountSuccess,
} from '@app/finxone-web-frontend/app/lib/actions/account.action';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { AccountState, AccountStateModel } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { buildHandleBarModel } from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { IconCacheService } from '@finxone-platform/shared/services';
import {
  APP_ZONES,
  AccountInfoType,
  AllowedCurrencyType,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Actions, Select, Store, ofActionDispatched } from '@ngxs/store';
import Handlebars from 'handlebars';
import { Observable, Subject, map, take, takeUntil } from 'rxjs';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-currency-listing',
  templateUrl: './currency-listing.component.html',
  styleUrl: './currency-listing.component.scss',
})
export class CurrencyListingComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  @Input() widgetAttributes: UiZoneWidgetAttributeConfig;
  @Input() contentStyle: baseCssConfigStyle;
  @Input() searchIconStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  public content = '';
  public searchText = '';
  public baseHandleBarModel: any;
  public templateFunction: HandlebarsTemplateDelegate<any>;
  public currenciesData: AllowedCurrencyType[];
  private isNavigationConfigured: boolean;
  @Select(AccountState.getAccounts)
  private accountState$!: Observable<AccountStateModel>;
  public accountsData: AccountInfoType[];
  public bankProvider: string;
  constructor(
    private actions: Actions,
    private store: Store,
    private _router: Router,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
  ) {}

  ngOnInit(): void {
    this.initHandleBars();
    this.accountState$
      .pipe(
        map((response) => {
          this.accountsData = response.accounts;
          this.bankProvider = response.paymentGatewayConfig.bankProvider;
        }),
      )
      .subscribe();
    this.currenciesData = this.widgetAttributes.widgetProperties.allowedCurrencies ?? [];
    this.isNavigationConfigured = !!(this.widgetAttributes?.['zone'] && this.widgetAttributes['pageUrl']);
  }
  private initHandleBars() {
    this.content = this.widgetAttributes.widgetProperties?.textContent ?? '';
    this.templateFunction = Handlebars.compile(this.content);
    buildHandleBarModel(this.store, '', this.countriesCurrenciesService, this.iconCacheService)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.baseHandleBarModel = model;
      });
  }

  searchCurrencies(event: any) {
    this.searchText = '';
    if (event.target.value.length) {
      if (!this.currenciesData.length)
        this.currenciesData = this.widgetAttributes.widgetProperties.allowedCurrencies ?? [];
      this.currenciesData = this.currenciesData.filter((v) =>
        v.code.toLowerCase().includes(event.target.value.toLowerCase()),
      );
      this.searchText = event.target.value;
    } else {
      this.currenciesData = this.widgetAttributes.widgetProperties.allowedCurrencies ?? [];
    }
  }

  renderTemplate(currency: AllowedCurrencyType) {
    return this.templateFunction({
      ...this.baseHandleBarModel,
      currencyCode: currency.code,
      currencyName: currency.name,
    });
  }

  public addCurrencyAccount(currency: AllowedCurrencyType) {
    this.store.dispatch(new CreateCurrencyAccount(currency.code));
    this.actions
      .pipe(
        ofActionDispatched(CreateCurrencyAccountSuccess),
        take(1),
        map(() => {
          this.handleRedirection();
        }),
      )
      .subscribe();
  }

  private handleRedirection() {
    if (this.isNavigationConfigured) {
      this._router.navigate([
        `/zones/${formatNameAsUrl(this.widgetAttributes['zone'])}/${this.widgetAttributes['pageUrl']}`,
      ]);
    } else {
      this._router.navigate([`/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/currency-accounts-landing`]);
    }
  }

  //looks for the currency code from the allowed currencies in the users accounts state to see if it already exists, only on currencyCloud payment provider
  //on currencyCloud you cant have more than one currency account for each currency
  public doesUserOwnCurrencyAccount(currencyCode: string): boolean {
    if (this.bankProvider === 'currencycloud') {
      return this.accountsData.some((account: AccountInfoType) => {
        return account.currency === currencyCode;
      });
    } else {
      return false;
    }
  }
}
